package ui.component.external

import emotion.react.css
import helpers.takeIfNotUndefined
import react.*
import react.dom.html.ReactHTML
import react.router.useNavigate
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.SelectedCategory
import ru.malygin.myConst.TimeDetectorItem
import ru.malygin.myConst.UrlLocal
import ru.malygin.myConst.WeekDay
import ui.component.MainScreenComponentsOpen
import ui.component.buttons.iconButton
import ui.component.buttons.miniIconButton
import ui.new_ui.components.card_handler.CardHandler
import ui.new_ui.components.card_item.CardItem
import ui.router.RouterRoute
import ui.styles.icons.CloseRoundedIconSVG
import ui.styles.icons.EditNoteIconSVG
import utils.logger.log
import utils.tech.TextWithUrls
import web.cssom.*
import web.dom.document
import web.html.HTMLDialogElement

//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
enum class NewDialogEnum(//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    val id: String,//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    val defaultFC: Any? = null,//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
){//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    EMPTY_DIALOG(//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
        id = "empty_dialog_id"//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    ),//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    ON_START_DIALOG(//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
        id = "on_start_dialog_id",//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
        defaultFC = newDialogOnStart//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    ),//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    MAIN_LIST_SUB_INFO_FOR_TEACHER_DIALOG(//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
        id = "main_list_sub_info_for_teacher_dialog_id",//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
        defaultFC = mainListSubInfoForTeacherDialog//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    )//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
}//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
data class NewDialogData(//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    val dialogInfo: NewDialogEnum = NewDialogEnum.EMPTY_DIALOG,//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    val titleText: String? = null,//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    val data__: List<MainScheduleItemDto>? = null,//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    val plusID:String? = null,//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
)//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
external interface NewDialogOnBackProps: Props {//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    var onBack: () -> Unit//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
}//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
external interface NewDialogProps: PropsWithChildren {//TODO ПОЛНОСТЬЮ ПЕРЕДЕЛАТЬ ДИЛОГ
    /**
     * default: [NewDialogData]
     */
    var dialogData: NewDialogData
    /**
     * default: false
     */
    var startByCreate: Boolean
    /**
     * default: true
     */
    var closeable: Boolean
}

fun toggleDialog(
    en: NewDialogEnum,
    plusID:String? = null,
){
    val dialogIsElement = document.getElementById(en.id.plus(plusID?:"")) as HTMLDialogElement?
    val dialogIsOpen = dialogIsElement?.open
    dialogIsElement?.let {element->
        dialogIsOpen?.let { open->
            if(open){
                element.close()
            }else{
                element.showModal()
            }
        }
    }
}

val NewDialog = FC<NewDialogProps>{props->
    val dialogData = props.dialogData.takeIfNotUndefined(defaultValue = NewDialogData())
    val startByDefault = props.startByCreate.takeIfNotUndefined(false)
    val closeable = props.closeable.takeIfNotUndefined(true)

    log.d("[New_Dialog] data = $dialogData & startByDefault = $startByDefault & closeable = $closeable")

    useEffectOnce {
        if (startByDefault){
            toggleDialog(dialogData.dialogInfo)
        }
    }

    ReactHTML.dialog{
        id = dialogData.dialogInfo.id.plus(dialogData.plusID?:"")
        className = ClassName("new_dialog_container")

        css(className) {

            backdrop {
                backgroundColor = rgb(0,0,0, 0.6)
            }
        }

        onClick = {mE->
//            log.d("[New_Dialog] ${mE.currentTarget} == ${mE.target} ${mE.currentTarget == mE.target}")
            if ((mE.currentTarget == mE.target) && closeable){
                toggleDialog(dialogData.dialogInfo)
            }
        }

        ReactHTML.div{
            className = ClassName("new_dialog_wrapper")

            css(className) {
                minHeight = 30.vh
                padding = Padding(vertical = 20.px, horizontal = 5.px)
                gap = 4.vh
                display = Display.flex
                flexDirection = FlexDirection.column
                alignItems = AlignItems.center
            }

            miniIconButton{
                onClick = {
                    toggleDialog(dialogData.dialogInfo)
                }
                realIconSVG = CloseRoundedIconSVG
            }

            dialogData.titleText?.let { titleText ->
                ReactHTML.div{
                    //title
                    className = ClassName("new_dialog_title")

                    +titleText
                }
            }

            ReactHTML.div{
                //content
                className = ClassName("new_dialog_content")

                when(val fc = dialogData.dialogInfo){
                    NewDialogEnum.EMPTY_DIALOG -> Unit

                    NewDialogEnum.ON_START_DIALOG -> {
                        fc.defaultFC.unsafeCast<FC<NewDialogOnBackProps>>().invoke {
                            onBack = {
                                toggleDialog(fc)
                            }
                        }
                    }

                    NewDialogEnum.MAIN_LIST_SUB_INFO_FOR_TEACHER_DIALOG -> {
                        fc.defaultFC.unsafeCast<FC<MainListSubInfoForTeacherDialogProps>>().invoke {
                            onBack = {
                                toggleDialog(fc)
                            }
                            data_ = dialogData.data__!!
                        }
                    }
                }

                +props.children
            }
        }
    }
}

private val newDialogOnStart = FC<NewDialogOnBackProps>{ props->
    val navigate = useNavigate()

    ReactHTML.div{

        css(className){
            display = Display.flex
            flexDirection = FlexDirection.column
            alignItems = AlignItems.center
            gap = 1.vh
        }

        ReactHTML.div{

            css(className) {
                border = Border(
                    width = 2.px,
                    style = LineStyle.solid,
                    color = Color("red")
                )
                borderRadius = 10.px
            }

            TextWithUrls(
                mainText = "Это неофициальное веб-приложение, созданное студентом ПРК, предназначено для удобного распространения расписания. Подробноее о приложении",
                urls = listOf(
                    UrlLocal(
                        text = "Подробноее о приложении",
                        url = RouterRoute.MORE_PAGE.route
                    )
                ),
                fontSize_ = FontSize.xLarge,
                plusTextClass = ClassName(""),
                onClick = {
                    props.onBack()
                    navigate(it)
                }
            ).giveMeText().invoke()
        }

        ReactHTML.h3{
            +"Расписание не выбрано.\nНажмите на кнопку ниже или на аналогичную справа сверху, чтобы перейти к выбору расписания."
        }

        iconButton{
            realIconSVG = EditNoteIconSVG
            plusMessageLeft = this.realIconSVG?.description
            onClick = {
                props.onBack()
                navigate(RouterRoute.CHANGE_SCHEDULE.route)
            }
        }
    }
}

private external interface MainListSubInfoForTeacherDialogProps: NewDialogOnBackProps{
    var data_: List<MainScheduleItemDto>
}

private val mainListSubInfoForTeacherDialog = FC<MainListSubInfoForTeacherDialogProps>{props ->
    val msComponentsOpen = MainScreenComponentsOpen(SelectedCategory.NONE)
    CardHandler{
        props.data_.forEach { item ->
            CardItem{
                css = {}
                msComponentsOpen.cardContent{
                    this.itemDto = itemDto
                    this.timeDetectorItem = TimeDetectorItem(
                        targetDay = 0,
                        dateAndNameOfDay = "0",
                        onlyDateOfDay = "0",
                        nameOfDay = WeekDay.MONDAY
                    )
                }
            }
        }
    }
}